import React, { FC } from 'react';
import { useField } from 'formik';

import TouristsPicker from '../TouristsPicker';
import { useCigarette } from '../../context';
import { FormTouristsPickerProps, TouristsValue } from './types';
import { FIELD_NAMES } from '../../constants';

export const FormTouristsPicker: FC<FormTouristsPickerProps> = ({
  name,
  className,
  variant,
  isOpenInitial,
}) => {
  const {
    state: { isMobile, isWizard },
  } = useCigarette();

  const touristsData = useField<TouristsValue>(name);
  const [{ value: touristsValue }, _meta, { setValue }] = touristsData;

  const [{ value: dateValue }] = useField(FIELD_NAMES.datepicker);

  if (isWizard && !dateValue) {
    return null;
  }

  const handleAdults = (value: TouristsValue['adults']) => {
    setValue({ ...touristsValue, adults: value });
  };

  const handleKids = (value: TouristsValue['kids']) => {
    setValue({ ...touristsValue, kids: value });
  };

  return (
    <TouristsPicker
      withDropdown={!isWizard}
      isMobile={isMobile}
      isWizard={isWizard}
      adultsValue={touristsValue.adults}
      kidsValue={touristsValue.kids}
      onChangeAdults={handleAdults}
      onChangeKids={handleKids}
      className={className}
      variant={variant}
      isOpenInitial={isOpenInitial}
    />
  );
};
